export default __webpack_public_path__ + "static/media/TR.f83bb84d.svg";